import { render } from "react-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import React from "react";

export default function PageTitle(props) {
  return (
    <>
      <HelmetProvider>
        <div>
          <Helmet>
            <title>{props.title}</title>
          </Helmet>
        </div>
      </HelmetProvider>
    </>
  );
}
